export const PERSONAL_POSSESSIONS = [
  {
    name: "specifiedItemsAwayFromHome",
    title: "Item details",
    description: "Are any of these items valued at more than £2,500?",
    form: {
      isShow: false,
      itemTypes: [
        {
          text: "Angling equipment",
          value: "AnglingEquipment",
        },
        {
          text: "Audio",
          value: "Audio",
        },
        {
          text: "Business equipment",
          value: "BusinessEquipment",
        },
        {
          text: "Camcorder",
          value: "Camcorder",
        },
        {
          text: "Clothing",
          value: "Clothing",
        },
        {
          text: "Coin collection",
          value: "CoinCollection",
        },
        {
          text: "Computer equipment",
          value: "ComputerEquipment",
        },
        {
          text: "Electric wheelchairs",
          value: "ElectricWheelchairs",
        },
        {
          text: "Electrical goods",
          value: "ElectricalGoods",
        },
        {
          text: "Gold items",
          value: "GoldItems",
        },
        {
          text: "Guns",
          value: "Guns",
        },
        {
          text: "Hearing aids",
          value: "HearingAids",
        },
        {
          text: "Jewellery or watches",
          value: "JewelleryOrWatches",
        },
        {
          text: "Medal collection",
          value: "MedalCollection",
        },
        {
          text: "Mobile Phone(s)",
          value: "MobilePhones",
        },
        {
          text: "Mobility Scooter/Carriage",
          value: "MobilityScooterOrCarriage",
        },
        {
          text: "Pedal Cycles",
          value: "PedalCycles",
        },
        {
          text: "Pedal Cycles - Powered",
          value: "PedalCyclesPowered",
        },
        {
          text: "Personal effects",
          value: "PersonalEffects",
        },
        {
          text: "Photographic equipment - amateur",
          value: "PhotographicEquipment",
        },
        {
          text: "Portable computers",
          value: "PortableComputers",
        },
        {
          text: "Precious metals",
          value: "PreciousMetals",
        },
        {
          text: "Spectacles",
          value: "Spectacles",
        },
        {
          text: "Sporting equipment",
          value: "SportingEquipment",
        },
        {
          text: "Sporting guns and shooting equipment",
          value: "SportingGunsAndShootingEquipment",
        },
        {
          text: "Stamp collection",
          value: "StampCollection",
        },
      ],
      dropDownLabel: "Item type",
      descriptionFieldLabel: "Item description",
      valueFieldLabel: "Item value",
      selectedItemType: null,
      descriptionFieldValue: null,
      valueFieldValue: null,
      valueFieldMinValue: "2,500",
      itemValueErrorMessage:
        "<strong>Sorry! </strong>Item value field format is invalid.",
    },
    itemsTitle: null,
    interfaceKeyPrefix: "PP",
    items: [],
    sectionHeading: "Items worth over £2,500",
    modalData: {
      showLink: false,
      ref: "showWhatsIncludedPersonalPossessions",
      title: "Items worth over £2,500",
    },
  },
];

export const PERSONAL_POSSESSIONS_D2C = [
  {
    name: "specifiedItemsAwayFromHome",
    title: "Item type",
    imageName: "personal-possessions.png",
    description:
      "Do you want to cover any items for loss or damage when taken away from the home that are worth more than £2,500 each?",
    form: {
      isShow: false,
      itemTypes: [
        {
          text: "Angling equipment",
          value: "AnglingEquipment",
        },
        {
          text: "Audio",
          value: "Audio",
        },
        {
          text: "Business equipment",
          value: "BusinessEquipment",
        },
        {
          text: "Camcorder",
          value: "Camcorder",
        },
        {
          text: "Clothing",
          value: "Clothing",
        },
        {
          text: "Coin collection",
          value: "CoinCollection",
        },
        {
          text: "Computer equipment",
          value: "ComputerEquipment",
        },
        {
          text: "Electric wheelchairs",
          value: "ElectricWheelchairs",
        },
        {
          text: "Electrical goods",
          value: "ElectricalGoods",
        },
        {
          text: "Gold items",
          value: "GoldItems",
        },
        {
          text: "Guns",
          value: "Guns",
        },
        {
          text: "Hearing aids",
          value: "HearingAids",
        },
        {
          text: "Jewellery or watches",
          value: "JewelleryOrWatches",
        },
        {
          text: "Medal collection",
          value: "MedalCollection",
        },
        {
          text: "Mobile Phone(s)",
          value: "MobilePhones",
        },
        {
          text: "Mobility Scooter/Carriage",
          value: "MobilityScooterOrCarriage",
        },
        {
          text: "Pedal Cycles",
          value: "PedalCycles",
        },
        {
          text: "Pedal Cycles - Powered",
          value: "PedalCyclesPowered",
        },
        {
          text: "Personal effects",
          value: "PersonalEffects",
        },
        {
          text: "Photographic equipment - amateur",
          value: "PhotographicEquipment",
        },
        {
          text: "Portable computers",
          value: "PortableComputers",
        },
        {
          text: "Precious metals",
          value: "PreciousMetals",
        },
        {
          text: "Spectacles",
          value: "Spectacles",
        },
        {
          text: "Sporting equipment",
          value: "SportingEquipment",
        },
        {
          text: "Sporting guns and shooting equipment",
          value: "SportingGunsAndShootingEquipment",
        },
        {
          text: "Stamp collection",
          value: "StampCollection",
        },
      ],
      dropDownLabel: "Item type",
      descriptionFieldLabel: "Item description",
      valueFieldLabel: "Item value",
      selectedItemType: null,
      descriptionFieldValue: null,
      valueFieldValue: null,
      valueFieldMinValue: "2,500",
      itemValueErrorMessage:
        "<strong>Sorry! </strong>Item value field format is invalid.",
    },
    itemsTitle: null,
    interfaceKeyPrefix: "PP",
    items: [],
    sectionHeading: "Personal possessions",
    modalData: {
      showLink: true,
      dialogComponentName: "DialogContentPersonalPossessions",
      title: "Personal possessions",
    },
  },
];

export const PERSONAL_POSSESSIONS_TENANT = [
  {
    name: "specifiedItemsAwayFromHome",
    title: "Item details",
    description: "Are any of these items valued at more than £2,500?",
    form: {
      isShow: false,
      itemTypes: [
        {
          text: "Angling equipment",
          value: "AnglingEquipment",
        },
        {
          text: "Audio",
          value: "Audio",
        },
        {
          text: "Business equipment",
          value: "BusinessEquipment",
        },
        {
          text: "Camcorder",
          value: "Camcorder",
        },
        {
          text: "Clothing",
          value: "Clothing",
        },
        {
          text: "Coin/Medal/Stamp Collection",
          value: "CoinMedalStampCollection",
        },
        {
          text: "Electric wheelchairs",
          value: "ElectricWheelchairs",
        },
        {
          text: "Electrical goods",
          value: "ElectricalGoods",
        },
        {
          text: "Hearing aids",
          value: "HearingAids",
        },
        {
          text: "Jewellery/Watches",
          value: "JewelleryOrWatches",
        },
        {
          text: "Mobile Phone(s)",
          value: "MobilePhones",
        },
        {
          text: "Pedal Cycles",
          value: "PedalCycles",
        },
        {
          text: "Personal effects",
          value: "PersonalEffects",
        },
        {
          text: "Photographic equipment - amateur",
          value: "PhotographicEquipment",
        },
        {
          text: "Portable computers",
          value: "PortableComputers",
        },
        {
          text: "Precious Metals or Stones",
          value: "PreciousMetalsOrStones",
        },
        {
          text: "Spectacles",
          value: "Spectacles",
        },
        {
          text: "Sporting equipment",
          value: "SportingEquipment",
        },
        {
          text: "Sporting guns and shooting equipment",
          value: "SportingGunsAndShootingEquipment",
        },
      ],
      dropDownLabel: "Item type",
      descriptionFieldLabel: "Item description",
      valueFieldLabel: "Item value",
      selectedItemType: null,
      descriptionFieldValue: null,
      valueFieldValue: null,
      valueFieldMinValue: "2,500",
      itemValueErrorMessage:
        "<strong>Sorry! </strong>Item value field format is invalid.",
    },
    itemsTitle: null,
    interfaceKeyPrefix: "PP",
    items: [],
    sectionHeading: "Items worth over £2,500",
    modalData: {
      showLink: false,
      ref: "showWhatsIncludedPersonalPossessionsTenantsContent",
      title: "Items worth over £2,500",
      helpDialogTitle: "World Wide Belongings Cover",
      textLinkToOpenPopup: "What is included in this?",
    },
  },
];

export const UNSPECIFIED_PERSONAL_POSSESSIONS = {
  isShow: false,
  description:
    "Do you require any additional cover for individual items when taken away from the home that are worth £2,500 or less?",
  lowerUnspecifiedAmounts: [
    {
      text: "£0",
      value: "Zero",
      numberValue: 0,
    },
    {
      text: "£1,500",
      value: "OneThousandFiveHundred",
      numberValue: 1500,
    },
    {
      text: "£2,500",
      value: "TwoThousandFiveHundred",
      numberValue: 2500,
    },
    {
      text: "£5,000",
      value: "FiveThousand",
      numberValue: 5000,
    },
    {
      text: "£10,000",
      value: "TenThousand",
      numberValue: 10000,
    },
    {
      text: "£15,000",
      value: "FifteenThousand",
      numberValue: 15000,
    },
  ],
  unspecifiedAmounts: [
    {
      text: "£0",
      value: "Zero",
      numberValue: 0,
    },
    {
      text: "£1,500",
      value: "OneThousandFiveHundred",
      numberValue: 1500,
    },
    {
      text: "£2,500",
      value: "TwoThousandFiveHundred",
      numberValue: 2500,
    },
    {
      text: "£5,000",
      value: "FiveThousand",
      numberValue: 5000,
    },
    {
      text: "£10,000",
      value: "TenThousand",
      numberValue: 10000,
    },
    {
      text: "£15,000",
      value: "FifteenThousand",
      numberValue: 15000,
    },
    {
      text: "£20,000",
      value: "TwentyThousand",
      numberValue: 20000,
    },
  ],
  sectionHeading: "Items worth £2,500 or less",
};

export const UNSPECIFIED_PERSONAL_POSSESSIONS_TENANT = {
  isShow: false,
  description:
    "Do you require any additional cover for individual items when taken away from the home that are worth £2,500 or less?",
  unspecifiedAmounts: [
    {
      text: "£0",
      value: "Zero",
      numberValue: 0,
    },
    {
      text: "£500",
      value: "FiveHundred",
      numberValue: 500,
    },
    {
      text: "£1,000",
      value: "OneThousand",
      numberValue: 1000,
    },
    {
      text: "£1,500",
      value: "OneThousandFiveHundred",
      numberValue: 1500,
    },
    {
      text: "£2,500",
      value: "TwoThousandFiveHundred",
      numberValue: 2500,
    },
    {
      text: "£5,000",
      value: "FiveThousand",
      numberValue: 5000,
    },
    {
      text: "£10,000",
      value: "TenThousand",
      numberValue: 10000,
    },
    {
      text: "£15,000",
      value: "FifteenThousand",
      numberValue: 15000,
    },
  ],
  sectionHeading: "Items worth £2,500 or less",
};

export const UNSPECIFIED_PERSONAL_POSSESSIONS_D2C = {
  isShow: false,
  imageName: "accidental-loss.png",
  description:
    "Do you require any cover for loss or damage of items worth £2,500 or less when taken away from the home?",
  standardUnspecifiedAmounts: [
    {
      text: "£0",
      value: "Zero",
      numberValue: 0,
    },
    {
      text: "£1,500",
      value: "OneThousandFiveHundred",
      numberValue: 1500,
    },
    {
      text: "£2,500",
      value: "TwoThousandFiveHundred",
      numberValue: 2500,
    },
    {
      text: "£5,000",
      value: "FiveThousand",
      numberValue: 5000,
    },
    {
      text: "£10,000",
      value: "TenThousand",
      numberValue: 10000,
    },
    {
      text: "£15,000",
      value: "FifteenThousand",
      numberValue: 15000,
    },
  ],
  higherUnspecifiedAmounts: [
    {
      text: "£0",
      value: "Zero",
      numberValue: 0,
    },
    {
      text: "£1,500",
      value: "OneThousandFiveHundred",
      numberValue: 1500,
    },
    {
      text: "£2,500",
      value: "TwoThousandFiveHundred",
      numberValue: 2500,
    },
    {
      text: "£5,000",
      value: "FiveThousand",
      numberValue: 5000,
    },
    {
      text: "£10,000",
      value: "TenThousand",
      numberValue: 10000,
    },
    {
      text: "£15,000",
      value: "FifteenThousand",
      numberValue: 15000,
    },
    {
      text: "£20,000",
      value: "TwentyThousand",
      numberValue: 20000,
    },
  ],
  modalData: {
    showLink: true,
    dialogComponentName: "DialogContentAdditionalLossOrDamage",
    title: "Personal possessions",
  },
  sectionHeading: "Additional loss or damage",
};

export const WWB_ITEMS_LIMIT = 15000;
